import type { SlideData } from "../../components/HeroSection/HeroSlide/HeroSlide";
import i18n from "../../i18nt/index";
import GenaralImg from "../../assets/pages/home/hero/general.jpg";
import GeoInfraMonitoringImg from "../../assets/pages/home/hero/geo-infra-monitoring.jpg";
import DesignImg from "../../assets/pages/home/hero/design.jpg"; // Assuming 'design.jpg' maps to 'Projektovanje'
import EnergyEfficiencyImg from "../../assets/pages/home/hero/energy-efficiency.jpg";
import EnvironmentalProtectionImg from "../../assets/pages/home/hero/environmental-protection.jpg";
import FireProtectionImg from "../../assets/pages/home/hero/fire-protection.jpg";
import FirstAidImg from "../../assets/pages/home/hero/first-aid.jpg";
import InspectionsTestingImg from "../../assets/pages/home/hero/inspections-testing.jpg"; // Assuming 'inspections-testing.jpg' maps to 'Pregledi i ispitivanja'
import PredictiveMaintenanceImg from "../../assets/pages/home/hero/predictive-maintenance.jpg";
import ProfessionalTrainingImg from "../../assets/pages/home/hero/professional-training.jpg"; // Assuming 'professional-training.jpg' maps to 'Stručno osposobljavanje i obuke'
import SiteSafetyCoordinatorImg from "../../assets/pages/home/hero/site-safety-coordinator.jpg"; // Assuming 'site-safety-coordinator.jpg' maps to 'Koordinator za bezbednost i zdravlje na gradilištima'
//import StandardizationImg from "../../assets/pages/home/hero/standardization.jpg";
import SupervisionImg from "../../assets/pages/home/hero/supervision.jpg"; // Assuming 'supervision.jpg' maps to 'Nadzor'
import WorkSafetyHealthImg from "../../assets/pages/home/hero/work-safety-health.jpg"; // Assuming 'work-safety-health.jpg' maps to 'Bezbednost i zdravlje na radu'
import { PAGES } from "../pages";

const heroKey = "pages.home.hero.slides";

export const heroSlides: SlideData[] = [
  {
    id: 1,
    title: i18n.t(`${heroKey}.slide1.title`),
    description: i18n.t(`${heroKey}.slide1.description`),
    ctaText: i18n.t(`${heroKey}.slide1.ctaText`),
    ctaLink: PAGES.CONTACT.route ?? "/",
    imageUrl: GenaralImg,
  },
  {
    id: 2,
    title: i18n.t(`${heroKey}.slide2.title`),
    description: i18n.t(`${heroKey}.slide2.description`),
    ctaText: i18n.t(`${heroKey}.slide2.ctaText`),
    ctaLink: PAGES.CONTACT.route ?? "/",
    imageUrl: GeoInfraMonitoringImg,
  },
  {
    id: 3,
    title: i18n.t(`${heroKey}.slide3.title`),
    description: i18n.t(`${heroKey}.slide3.description`),
    ctaText: i18n.t(`${heroKey}.slide3.ctaText`),
    ctaLink: PAGES.CONTACT.route ?? "/",
    imageUrl: SupervisionImg, // Mapped to 'Nadzor'
  },
  {
    id: 4,
    title: i18n.t(`${heroKey}.slide4.title`),
    description: i18n.t(`${heroKey}.slide4.description`),
    ctaText: i18n.t(`${heroKey}.slide4.ctaText`),
    ctaLink: PAGES.CONTACT.route ?? "/",
    imageUrl: PredictiveMaintenanceImg,
  },
  {
    id: 5,
    title: i18n.t(`${heroKey}.slide5.title`),
    description: i18n.t(`${heroKey}.slide5.description`),
    ctaText: i18n.t(`${heroKey}.slide5.ctaText`),
    ctaLink: PAGES.CONTACT.route ?? "/",
    imageUrl: WorkSafetyHealthImg, // Mapped to 'Bezbednost i zdravlje na radu'
  },
  {
    id: 6,
    title: i18n.t(`${heroKey}.slide6.title`),
    description: i18n.t(`${heroKey}.slide6.description`),
    ctaText: i18n.t(`${heroKey}.slide6.ctaText`),
    ctaLink: PAGES.CONTACT.route ?? "/",
    imageUrl: SiteSafetyCoordinatorImg, // Mapped to 'Koordinator za bezbednost i zdravlje na gradilištima'
  },
  {
    id: 7,
    title: i18n.t(`${heroKey}.slide7.title`),
    description: i18n.t(`${heroKey}.slide7.description`),
    ctaText: i18n.t(`${heroKey}.slide7.ctaText`),
    ctaLink: PAGES.CONTACT.route ?? "/",
    imageUrl: EnergyEfficiencyImg,
  },
  {
    id: 8,
    title: i18n.t(`${heroKey}.slide8.title`),
    description: i18n.t(`${heroKey}.slide8.description`),
    ctaText: i18n.t(`${heroKey}.slide8.ctaText`),
    ctaLink: PAGES.CONTACT.route ?? "/",
    imageUrl: DesignImg, // Mapped to 'Projektovanje'
  },
  {
    id: 9,
    title: i18n.t(`${heroKey}.slide9.title`),
    description: i18n.t(`${heroKey}.slide9.description`),
    ctaText: i18n.t(`${heroKey}.slide9.ctaText`),
    ctaLink: PAGES.CONTACT.route ?? "/",
    imageUrl: FireProtectionImg,
  },
  {
    id: 10,
    title: i18n.t(`${heroKey}.slide10.title`),
    description: i18n.t(`${heroKey}.slide10.description`),
    ctaText: i18n.t(`${heroKey}.slide10.ctaText`),
    ctaLink: PAGES.CONTACT.route ?? "/",
    imageUrl: EnvironmentalProtectionImg,
  },
  /*{
    id: 11,
    title: i18n.t(`${heroKey}.slide11.title`),
    description: i18n.t(`${heroKey}.slide11.description`),
    ctaText: i18n.t(`${heroKey}.slide11.ctaText`),
    ctaLink: PAGES.CONTACT.route ?? "/",
    imageUrl: StandardizationImg,
  },*/
  {
    id: 12,
    title: i18n.t(`${heroKey}.slide12.title`),
    description: i18n.t(`${heroKey}.slide12.description`),
    ctaText: i18n.t(`${heroKey}.slide12.ctaText`),
    ctaLink: PAGES.CONTACT.route ?? "/",
    imageUrl: FirstAidImg,
  },
  {
    id: 13,
    title: i18n.t(`${heroKey}.slide13.title`),
    description: i18n.t(`${heroKey}.slide13.description`),
    ctaText: i18n.t(`${heroKey}.slide13.ctaText`),
    ctaLink: PAGES.CONTACT.route ?? "/",
    imageUrl: ProfessionalTrainingImg, // Mapped to 'Stručno osposobljavanje i obuke'
  },
  {
    id: 14,
    title: i18n.t(`${heroKey}.slide14.title`),
    description: i18n.t(`${heroKey}.slide14.description`),
    ctaText: i18n.t(`${heroKey}.slide14.ctaText`),
    ctaLink: PAGES.CONTACT.route ?? "/",
    imageUrl: InspectionsTestingImg, // Mapped to 'Pregledi i ispitivanja'
  },
];
